import './progress-bar-style.scss'

import React, { useEffect, useState } from 'react'

const ProgressBar = () => {
  const [scroll, setScroll] = useState(0)

  useEffect(() => {
    const progressBarHandler = () => {
      const totalScroll = document.documentElement.scrollTop
      const windowHeight =
        document.documentElement.scrollHeight -
        (document.documentElement.clientHeight + 660)
      const s = `${totalScroll / windowHeight}`

      setScroll(s)
    }

    window.addEventListener('scroll', progressBarHandler)

    return () => window.removeEventListener('scroll', progressBarHandler)
  })
  return (
    <div id="progressBarContainer">
      <div id="progressBar" style={{ transform: `scale(${scroll}, 1)` }} />
    </div>
  )
}

export default ProgressBar
